import type { CarnivalGameState, ValidationResult } from "../types";

export const ok: ValidationResult = { valid: true };

export function fail(
  error: string,
  details?: Record<string, unknown>,
): ValidationResult {
  return { valid: false, error, details };
}

export function validateActor(
  state: CarnivalGameState,
  playerId: string,
): ValidationResult {
  if (!state.players.some((player) => player.playerId === playerId)) {
    return fail("Unknown player", { playerId });
  }
  return ok;
}
